import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import socketService from '../services/socketService'; 

const Layout = ({ children }) => {
    const [showFloatingBtns, setShowFloatingBtns] = useState(true); 
    const username = localStorage.getItem('adminUsername') || 'Admin';
    const whatsappLink = 'https://wa.me/88017xxxxxxxx'; 
    
    const location = useLocation();
    const navigate = useNavigate();

    // ==============================================================
    // 🔥 Permission Logic
    // ==============================================================
    const isMainAdmin = localStorage.getItem('isMaster') === 'true'; 
    
    let permissions = {};
    try {
        permissions = JSON.parse(localStorage.getItem('permissions') || '{}');
    } catch (e) {
        permissions = {};
    }

    const hasPermission = (key) => {
        if (isMainAdmin) return true; 
        return permissions[key] === true; 
    };

    // সাধারণ লগআউট ফাংশন
    const handleLogout = () => {
        try {
            if (socketService && typeof socketService.disconnect === 'function') {
                socketService.disconnect();
            }
        } catch (error) {
            console.error("Logout Error:", error);
        }
        
        localStorage.clear(); 
        sessionStorage.clear();
        
        navigate('/'); 
        window.location.reload(); 
    };

    // ==============================================================
    // 🔥 Socket Listener for Global Logout
    // ==============================================================
    useEffect(() => {
        const socket = socketService.getSocket();
        
        if (!socket) return; 

        const handleForceLogout = (data) => {
            alert(data?.message || 'Permission Changed! You are being logged out.');
            handleLogout();
        };

        const handleGlobalLogout = (data) => {
            alert(data?.message || '⚠️ Security Alert: All admins are being logged out by Master Admin.');
            handleLogout();
        };

        socket.on('forceLogout', handleForceLogout);
        socket.on('force_logout_global', handleGlobalLogout);

        return () => {
            socket.off('forceLogout', handleForceLogout);
            socket.off('force_logout_global', handleGlobalLogout);
        };
    }, []);

    // ==============================================================
    // 🔥 Mobile Viewport Logic & Scroll Logic
    // ==============================================================
    useEffect(() => {
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);
        if (isMobile) {
            const viewportMeta = document.querySelector("meta[name=viewport]");
            if (viewportMeta) {
                viewportMeta.setAttribute("content", "width=1684, initial-scale=0.7");
            }
        }
    }, []);

    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop){
                 setShowFloatingBtns(false); 
            } else {
                 setShowFloatingBtns(true);
            }
            lastScrollTop = st <= 0 ? 0 : st;
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []); 

    const isActive = (path) => location.pathname === path ? 'active' : '';

    return (
        <div className="layout-container">
            
            {/* -------------------- 1. টপ হেডার -------------------- */}
            <header className="top-header">
                <div className="brand-container">
                    <img src="/logo.png" alt="Logo" className="header-logo"/>
                    <h5 className="brand-text">Dabit Pay</h5>
                </div>
                
                <div className="header-right">
                     <span className="user-name">Hi, {username}</span>
                     <button type="button" onClick={handleLogout} className="logout-btn-header">Logout</button>
                </div>
            </header>

            {/* -------------------- 2. সাইডবার -------------------- */}
            <div id="sidebar" className="sidebar">
                <div className="sidebar-content">
                    
                    <p className="menu-label">MAIN Dashboard</p>
                    <nav className="nav flex-column">
                        <Link className={`nav-link ${isActive('/dashboard')}`} to="/dashboard">📊 Dashboard</Link> 

                         {hasPermission('permissonUserlist') && (
                              <Link className={`nav-link ${isActive('/users')}`} to="/users">👥 Users List</Link>
                        )}

                         {hasPermission('permissonUserdevices') && (
                              <Link className={`nav-link ${isActive('/user_devices')}`} to="/user_devices">📱 User Devices</Link>
                        )}
                    </nav>

                    <p className="menu-label">TRANSACTIONS</p>
                    <nav className="nav flex-column">
                        {hasPermission('permissonMobileBank') && (
                            <Link className={`nav-link ${isActive('/mobile_banking')}`} to="/mobile_banking">🏦 Mobile Banking</Link> 
                        )}
                        
                        {hasPermission('permissonSendPayment') && (
                            <Link className={`nav-link ${isActive('/pending_list')}`} to="/pending_list">💸 Payment Send </Link> 
                        )}
                        
                        {hasPermission('permissonPaymentReceived') && (
                            <Link className={`nav-link ${isActive('/payment_receive')}`} to="/payment_receive">📥 Payment Received</Link>
                        )}

                        {hasPermission('apptransactionscheck') && (
                            <Link className={`nav-link ${isActive('/app_transactions')}`} to="/app_transactions">📱 App Transactions</Link>
                        )}

                        {hasPermission('permissonJobTracker') && (
                            <Link className={`nav-link ${isActive('/job_tracker')}`} to="/job_tracker">⚡ Job Tracker</Link>
                        )}

                           {hasPermission('permissonAccount') && (
                            <Link className={`nav-link ${isActive('/account_tasks')}`} to="/account_tasks">⚡ Account Manger</Link>
                        )}

                        <Link className={`nav-link ${isActive('/NumberCalculator')}`} to="/NumberCalculator">🧮 Calculator</Link>

                    </nav>

                    {(hasPermission('permissonGetsms') || 
                      hasPermission('permissonAddsms') || 
                      hasPermission('permissonAPPreceive') || 
                      hasPermission('permissonCode')) && (
                        <>
                            <p className="menu-label">SMS & APPS</p>
                            <nav className="nav flex-column">
                                {hasPermission('permissonGetsms') && (
                                    <Link className={`nav-link ${isActive('/smsget')}`} to="/smsget">📩 Get SMS</Link>
                                )}
                                
                                {hasPermission('permissonAddsms') && (
                                    <Link className={`nav-link ${isActive('/sms')}`} to="/sms">✍️ Add SMS</Link>
                                )}
                                
                                {hasPermission('permissonAPPreceive') && (
                                    <Link className={`nav-link ${isActive('/app_receive')}`} to="/app_receive">📲 App SMS</Link>
                                )}
                                
                                {hasPermission('permissonCode') && (
                                    <Link className={`nav-link ${isActive('/codes')}`} to="/codes">🔢 Security Codes</Link>
                                )}
                            </nav>
                        </>
                    )}

                    <p className="menu-label">SETTINGS</p>
                    <nav className="nav flex-column">
                        {hasPermission('permissonAPIkey') && (
                            <Link className={`nav-link ${isActive('/api_keys')}`} to="/api_keys">🔑 API Configuration</Link>
                        )}
                        
                        {isMainAdmin && (
                            <Link className={`nav-link ${isActive('/master_keys')}`} to="/master_keys">🛡️ Master Keys</Link>
                        )}

                        {hasPermission('permissonApiview') && (
                            <Link className={`nav-link ${isActive('/api_logs')}`} to="/api_logs">🛡️ API VIEW</Link>
                        )}

                        {isMainAdmin && (
                            <Link className={`nav-link ${isActive('/otp_view')}`} to="/otp_view">📱 OTP VIEW</Link>
                        )}

                          {isMainAdmin && (
                            <Link className={`nav-link ${isActive('/deposit_monitor')}`} to="/deposit_monitor">🛡️ Deposit VIEW</Link>
                        )}
                        
                        {isMainAdmin && (
                            <Link className={`nav-link ${isActive('/bot_codes')}`} to="/bot_codes">🤖 BOOT Api</Link>
                        )}

                        <Link className={`nav-link ${isActive('/device-setup')}`} to="/device-setup">📱 Device Setup Admin</Link>

                        <Link className={`nav-link ${isActive('/change_password')}`} to="/change_password">🔒 Change Password</Link>
                        
                        {hasPermission('permissonSeenBy') && (
                            <Link className={`nav-link ${isActive('/update_seen')}`} to="/update_seen">👁️ Update Seen Status</Link>
                        )}

                         {isMainAdmin && (
                            <Link className={`nav-link ${isActive('/commission_setting')}`} to="/commission_setting">💰 Commission Setting</Link>
                        )}

                        {isMainAdmin && (
                            <a className="nav-link" href="/debit_security/master">🛡️ Dabit security</a>
                        )}

                       {/* 🔥 নতুন যোগ করা Download Doc অপশন 🔥 */}
<a 
    href="/Dabit Pay Live API Documentati.pdf" 
    download="Dabit_Pay_Live_API_Documentation.pdf" 
    className="nav-link" 
    style={{ marginTop: '15px', borderTop: '1px solid #334155', paddingTop: '15px', color: '#38bdf8' }}
>
    📄 Download Doc
</a>
                        
                    </nav>
                </div>
            </div>

            {/* -------------------- 3. মেইন কন্টেন্ট -------------------- */}
            <div className="main-content">
                <div className="page-content">
                    {children}
                </div>
            </div>
            
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-float" style={{ display: showFloatingBtns ? 'flex' : 'none' }}>
                <img src="/whatsapp.png" alt="WA" className="whatsapp-icon"/>
            </a>

            <style jsx global>{`
                /* ========== General ========== */
                body { 
                    background-color: #f0f2f5; 
                    display: flex; min-height: 100vh; 
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    margin: 0;
                    min-width: 1480px;
                    overflow-x: auto;
                }

                /* ========== Top Header ========== */
                .top-header {
                    position: fixed; top: 0; left: 0; width: 100%; height: 70px;
                    background: #0f172a; display: flex; align-items: center; justify-content: space-between;
                    padding: 0 25px; box-shadow: 0 2px 10px rgba(0,0,0,0.2); z-index: 1300;
                    overflow: hidden;
                }

                .top-header::before {
                    content: ""; position: absolute; top: 0; left: -75%; width: 50%; height: 100%;
                    background: linear-gradient(120deg, rgba(255,255,255,0.0), rgba(255,255,255,0.15), rgba(255,255,255,0.0));
                    transform: skewX(-20deg); animation: shimmer 4s infinite; pointer-events: none;
                }

                .brand-container { display: flex; align-items: center; gap: 15px; z-index: 2; }
                .header-logo { width: 40px; height: 40px; border-radius: 50%; background: white; padding: 2px; }
                .brand-text { color: white; margin: 0; font-weight: 700; letter-spacing: 1px; font-size: 20px; }

                .header-right { z-index: 2; display: flex; align-items: center; gap: 20px; }
                .user-name { color: #cbd5e1; font-weight: 600; }
                .logout-btn-header {
                    padding: 6px 15px; background: #ef4444; color: white; border: none; border-radius: 4px;
                    font-weight: 600; cursor: pointer; transition: 0.2s; font-size: 13px;
                }
                .logout-btn-header:hover { background: #dc2626; }

                /* ========== Sidebar ========== */
                .sidebar { 
                    width: 260px; background: #1e293b; color: #94a3b8; 
                    position: fixed; top: 70px; bottom: 0; left: 0; z-index: 1200; 
                    box-shadow: 4px 0 15px rgba(0,0,0,0.1); display: flex; flex-direction: column;
                    border-right: 1px solid #334155;
                }
                
                .sidebar-content { flex-grow: 1; padding: 15px; overflow-y: auto; }

                .menu-label { font-size: 14px; font-weight: 900; color: #72e407; margin-top: 15px; margin-bottom: 5px; padding-left: 10px; }
                
                .sidebar a.nav-link { 
                    color: #cbd5e1; padding: 10px 15px; border-radius: 8px; margin-bottom: 4px;
                    font-size: 17px; font-weight: 500; transition: all 0.2s; display: flex; align-items: center; gap: 10px;
                    text-decoration: none; 
                }
                .sidebar a.nav-link:hover { background-color: #334155; color: white; transform: translateX(5px); }
                
                .sidebar a.nav-link.active { background-color: #3b82f6; color: white; box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3); }

                /* ========== Main Content ========== */
                .main-content { margin-left: 260px; padding: 25px; padding-top: 95px; flex-grow: 1; }

                @keyframes shimmer { 0% { left: -75%; } 100% { left: 125%; } }
                .whatsapp-float {
                    position: fixed; bottom: 25px; right: 25px; width: 50px; height: 50px;
                    background: #25D366; border-radius: 50%; display: flex; align-items: center; justify-content: center;
                    box-shadow: 0 4px 15px rgba(37, 211, 102, 0.4); z-index: 1000; transition: transform 0.2s;
                }
                .whatsapp-float:hover { transform: scale(1.1); }
                .whatsapp-icon { width: 30px; height: 30px; filter: invert(1); }
            `}</style>
        </div>
    );
};

export default Layout;